import React from 'react';
import RegistrationPage from '../components/login_form/RegistrationPage';
import Login from '../components/login_form/Login';
import { Routes, Route } from 'react-router-dom';
import Branch_Login from '../components/login_form/Branch_Login';

const AccessDenied = () => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            backgroundColor: '#f8d7da',
            color: '#721c24',
            fontFamily: '"Segoe UI", sans-serif',
            padding: '20px',
            textAlign: 'center'
        }}>
            <h1 style={{ fontSize: '2.5rem', margin: 0 }}>Access Denied</h1>
        </div>
    );
};

const AuthRoute = () => {
    return (
        <div className="App">
            <Routes>
                <Route path="/" element={<AccessDenied />} />
                <Route path="/:customerCode" element={<Login />} />
                <Route path='/signUp' element={<RegistrationPage />} />
                <Route path='/branch_login' element={<Branch_Login />} />
            </Routes>
        </div>
    )
}

export default AuthRoute

